import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { RequestNatureOptions } from "@shared/enums/request-nature-options";
import { BaseRef } from "@shared/models/BaseRef";
import { ContactFormService } from "@shared/services/contact-form.service";
import { DropdownModule } from "primeng/dropdown";

@Component({
  selector: "app-attestation-details",
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, DropdownModule, TranslateModule],
  templateUrl: "./attestation-details.component.html",
})
export class AttestationDetailsComponent {
  @Input() form!: FormGroup;
  @Input() attestationOptions: BaseRef[] = [];
  @Input() isGeneratedOptions: { label: string; value: boolean }[] = [];
  @Input() documentTypes: BaseRef[] = [];
  RequestNatureOptions = RequestNatureOptions;
  constructor(private readonly contactFormService: ContactFormService) {}

  updateAttestationTrame() {
    this.contactFormService.updateAttestationTrame(this.form);
  }
}
